import React from "react";
import svg183 from "../../assets/svg/svg183.svg";

function Security() {
  const badges = [
    "Bank-level encryption",
    "PCI-DSS & ISO aligned",
    "99.95% Uptime",
  ];

  const stats = [
    { value: "T +1", label: "Average Settlement Time" },
    { value: "99.9%", label: "Reconciliation Accuracy" },
  ];

  return (
    <div className="flex lg:flex-row flex-col gap-y-[2rem] lg:gap-[3rem] justify-between text-white w-full lg:items-stretch">
      {/* Left — title + shield + badges */}
      <div className="flex flex-col w-full">
        <div className="flex flex-row items-start gap-[1.5rem]">
          <div className="text-[rgba(250,250,250,0.90)] font-lexend text-[2rem] lg:text-[3rem] font-[600] leading-[2.75rem] lg:leading-[3.5rem] tracking-[-0.15rem] max-w-[30rem]">
            Your Money is Secure. Every Step. Every Transaction.
          </div>
          <img src={svg183} alt="shield" className="w-[6rem] h-[6rem] flex-shrink-0 hidden sm:block" />
        </div>

        <div className="mt-auto pt-[1.5rem] flex flex-wrap gap-[.75rem]">
          {badges?.map((badge, i) => (
            <span
              key={i}
              className="rounded-[624.9375rem] bg-[rgba(255,255,255,0.10)] shadow-[0_0_0_1px_rgba(255,255,255,0.15)] px-[.75rem] py-[.5rem] text-white font-lexend text-[.875rem] font-[400] leading-[1.5rem] tracking-[-0.00875rem] whitespace-nowrap"
            >
              {badge}
            </span>
          ))}
        </div>
      </div>

      {/* Right — desc + stats */}
      <div className="flex flex-col w-full">
        <div className="text-[#F6F6F8] font-lexend text-[1.125rem] font-[400] leading-[1.625rem] tracking-[-0.0135rem] capitalize max-w-[30rem]">
          Built with bank-level security, real-time monitoring, and full audit trails—so you never lose money, data, or control.
        </div>

        <div className="mt-auto pt-[1.5rem] flex flex-row gap-[3rem] w-full">
          {stats?.map((stat, i) => (
            <div key={i} className="flex flex-col">
              <span className="text-[rgba(250,250,250,0.90)] font-lexend text-[2rem] font-[400] tracking-[-0.34875rem]">{stat?.value}</span>
              <span className="mt-[.5rem] text-[rgba(250,250,250,0.50)] font-lexend text-[1rem] font-[400] capitalize">{stat?.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Security;
